import { string } from "zod"

const ErrorMessage = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#fef2f2",
      }}
    >
      <div
        style={{
          padding: "20px",
          maxWidth: "500px",
          textAlign: "center",
          border: "1px solid #f44336",
          borderRadius: "8px",
          backgroundColor: "#fff",
          color: "#b71c1c",
        }}
      >
        <h1 style={{ marginBottom: "12px", fontSize: "1.8rem", fontWeight: "700" }}>
          Oops! Something went wrong
        </h1>
        <p style={{ fontSize: "1.1rem", marginBottom: "12px" }}>
          There was a problem fetching the data. Please try again.
        </p>
        <p style={{ fontSize: "0.95rem", color: "#880e4f" }}>
          Open the browser console for more details and send the error info to our tech support
          team.
        </p>
      </div>
    </div>
  )
}

export default ErrorMessage
